import { action } from 'satcheljs/lib/legacy';
import { logUsage } from 'owa-analytics';
import FilePickerFilterOptionsState from '../store/schema/FilePickerFilterOptionsState';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';

export default action('setSelectedFilterOption')(function setSelectedFilterOption(
    optionsState: FilePickerFilterOptionsState,
    newValue: AttachmentItemsFilterBy
) {
    logUsage('FPAttachmentsFilter', [newValue]);

    optionsState.selectedFilterOption = newValue;
});
